// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"746":"fe5831c4","872":"256e97b9","978":"8dfe0c77"}[chunkId] + ".chunk.js";
};